import React from 'react';
import CopyLink from './copyLink.js'
import {Link} from "react-router-dom";
import {_printNumber} from '../helpers/helpers.js'

import {RtHeader} from '../../../server/routes/route-types.js'

interface SectionHeaderProps {
    header: RtHeader | null | undefined;
    link?: string;
    anchor?: string;
}

export default function SectionHeader({header,link,anchor}: SectionHeaderProps) {

	if (!header) return (<></>);

	return (<>
		<div>
			<h3 id={anchor}
				style={{wordWrap: 'break-word'}} 
				className="text-left"
			>
				{header.Title}
				<CopyLink link={link}  anchor={anchor}/> 
			</h3>
			{header.Subtitle}
			{
				!!header.DomainCount &&
				<>
					<br/>
					<br/>
					List of <b>{_printNumber(header.DomainCount)}</b> websites affected by{' '} 
					<Link 
					to={header.Link!}
					className="link-hover" 
				>
					<b>{header.LinkText}</b>
				</Link>					
				</>
			}

		</div>
	</>)
}
